<template>
  <clinic-history-variable-chart
    v-bind="$attrs"
    v-on="$listeners"
    :variableName="HEALTH_CONDITION_TODAY"
    :chartData="chartData"
    :additionalSeries="moodSeries ? [moodSeries] : []"
    coloringPoints
    :maxValue="10"
    :titleChart="titleChart"
    :yAxisAdditional="yAxisAdditional ? this.yAxisAdditional : []"
    typeChart="areaspline"
    :hideMainSeriesByDefault="showMoodOnly"
  :hideAdditionalSeriesByDefault="showVarOnly"
  />
</template>

<script>
import ClinicHistoryVariableChart from '@/components/shared/ClinicHistoryVariableChart.vue'
import { HEALTH_CONDITION_TODAY } from '@/constants/clinicHistory'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

// function getEmojiSrc (fileName) {
// 	const ROOT_RELATIVE_PATH = '/static-appopensalud/img/icons/emojis/'
// 	return ROOT_RELATIVE_PATH + fileName
// }
// const tickIcons = {
//   1: { src: getEmojiSrc('emoji-very-sad.svg'), color: RED_COLOUR },
//   2: { src: getEmojiSrc('emoji-no-feelings.svg'), color: YELLOW_COLOUR },
//   3: { src: getEmojiSrc('emoji-happy.svg'), color: GREEN_COLOUR }
// }
export default {
  name: 'TodayHealthConditionChart',
  components: { ClinicHistoryVariableChart },
  inheritAttrs: false,
  mixins: [i18nMixin(I18N_FILE)],
  props: {
    chartData: {
      type: Object,
      default: () => ({ variableData: [], moodsData: [] })
    },
     focusSeries: {
     type: String,
     default: 'variable'
   }
  },
  data () {
    return { HEALTH_CONDITION_TODAY,
      titleChart: this.$t('how-do-you-feel-week', { name: this.$store.state.session.user.firstName }),
      yAxisAdditional: [
      //   {
      //     title: { text: this.$t('mood') },
      //     labels: {
      //       /* usando el helper */
      //       formatter () {
      //         const icon = tickIcons[this.value]
      //       if (!icon) return this.value
      //       return `<span
      //                 style="
      //                   display:inline-block;
      //                   width:22px;height:22px;
      //                   background-color:${icon.color};
      //                   -webkit-mask:url('${icon.src}') center/contain no-repeat;
      //                   mask:          url('${icon.src}') center/contain no-repeat;
      //                 ">
      //               </span>`
      //       },
      //       useHTML: true,
      //       style: { fontSize: '22px', lineHeight: '1' }
      //     },
      //     min: 1,
      //     tickPositions: [0, 1, 2, 3],
      //     gridLineWidth: 0.25,
      //     opposite: true
      //   }
       ]
     }
  },
  computed: {
    showMoodOnly () { return this.focusSeries === 'mood' },
    showVarOnly () { return this.focusSeries === 'variable' },
    /* Serie de estados de ánimo que se dibujará SIEMPRE por encima de la principal */
    moodSeries () {
      if (!this.chartData.moodsData.length) return null

    //   const moodArray = this.chartData.moodsData.map(m => {
    //     const xVal = new Date(m.date).getTime()
    //     const yVal =
    //       m.typeMood === typeMood.POSITIVE
    //         ? typeMood.POSITIVE
    //         : m.typeMood === typeMood.NEGATIVE
    //           ? typeMood.NEGATIVE
    //           : typeMood.NEUTRAL

    //     return {
    //       x: xVal,
    //       y: yVal,
    //       moodName: this.$i18nHelpers.normalize(m.name),
    //       color:
    //         m.typeMood === typeMood.POSITIVE
    //           ? GREEN_COLOUR
    //           : m.typeMood === typeMood.NEGATIVE
    //             ? RED_COLOUR
    //             : YELLOW_COLOUR
    //     }
    //   })

    //   if (!moodArray.length) return null

    //   return {
    //     name: this.$t('mood-title'),
    //     data: moodArray,
    //     type: 'spline',
    //     yAxis: 1,
    //     color: GRAY_COLOUR,
    //     lineWidth: 1.5,
    //     marker: { enabled: true, radius: 5 },
    //     /* Z‑index alto para que la línea quede por encima del área */
    //     zIndex: 15,
    //     customTooltipFormatter () {
    //   const dateStr = new Date(this.x).toLocaleDateString()
    //   const colorMarker = `<span style="color:${this.point.color}">●</span>`
    //   return `${colorMarker}<strong>${this.series.name}</strong><br/>${dateStr}: ${this.point.moodName}`
    // }
    //   }
    }
  }
  // mounted () {
  //   if (this.chartData.moodsData.length === 0) {
  //     ClinicHistoryRepository().getHistoryMoods()
  //       .then(res => { this.chartData.moodsData = res.data || [] })
  //       .catch(err => console.error('Error loading moods:', err))
  //   }
  // }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/TodayHealthConditionChart.vue